module.exports = __webpack_public_path__ + "static/media/intro.d4e3025e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro.jpg
// module id = 699
// module chunks = 2